module.exports = __webpack_public_path__ + "static/media/float_back_btne097b0e7b89f53dc9a24b75844ff734b.webp";